export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right'
}
